import {Component, inject, OnInit} from '@angular/core';
import {AccessService} from "../../services/access.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {DataService} from "../../services/data.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {DatePipe, DecimalPipe, NgIf} from "@angular/common";
import moment from "moment";

@Component({
    selector: 'app-price-list-detail',
    imports: [NgIf, ReactiveFormsModule, DatePipe, FormsModule, DecimalPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-table-list me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Preisliste anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Preisliste bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Preisliste
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <div class="row">
                        <div class="col">
                            <label>Name</label>
                            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.name }}</p>
                        </div>
                        <div class="col">
                            <label>Währung</label>
                            <input type="text" class="form-control" formControlName="currency" placeholder="EUR" [maxlength]="3" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.currency }}</p>
                        </div>
                        @if (viewMode != ViewMode.INSERT) {
                            <div class="col">
                                <label>Erstellt am</label>
                                <p>{{ form.value.created_at | date: 'dd.MM.yyyy' }}</p>
                            </div>
                        }
                        <div class="col">
                            <label>Gültig von</label>
                            <input type="date" class="form-control" formControlName="valid_from" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.valid_from | date: 'dd.MM.yyyy' }}</p>
                        </div>
                        <div class="col">
                            <label>Gültig bis</label>
                            <input type="date" class="form-control" formControlName="valid_to" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW">
                                {{ form.value.valid_to | date: 'dd.MM.yyyy' }}
                                @if (form.value.valid_to == null) {
                                    <span class="text-muted">Nicht gesetzt</span>
                                }
                            </p>
                        </div>
                    </div>
                </form>

                <label class="form-label">Produkte</label>
                <div class="table-responsive">
                    <table class="table table-sm">
                        <thead>
                        <tr>
                            <th style="width: 150px">Artikelnummer</th>
                            <th>Name</th>
                            <th class="text-end">Steuersatz (%)</th>
                            <th class="text-center" colspan="2">Empfohlener Preis (€)</th>
                            <th class="text-center" colspan="2">Höchster Preis (€)</th>
                            <!--@if (viewMode != ViewMode.INSERT) {
                                <th style="width: 150px">Geändert am</th>
                            }-->
                        </tr>
                        <tr>
                            <th></th>
                            <th></th>
                            <th style="width: 120px"></th>
                            <th style="width: 120px" class="text-end">Netto</th>
                            <th style="width: 120px" class="text-end">Brutto</th>
                            <th style="width: 120px" class="text-end">Netto</th>
                            <th style="width: 120px" class="text-end">Brutto</th>
                            <!--@if (viewMode != ViewMode.INSERT) {
                                <th></th>
                            }-->
                        </tr>
                        </thead>
                        <tbody>
                            @for (product of products; track product; let i = $index) {
                                <tr>
                                    <td>{{product.article_number}}</td>
                                    <td>{{product.name}}</td>
                                    <td class="text-end">
                                        @if (viewMode == ViewMode.VIEW) {
                                            {{ product.pli_tax_rate }}
                                            <span class="text-muted" *ngIf="!product.pli_tax_rate">Nicht gesetzt</span>
                                        } @else {
                                            <input type="number" class="form-control form-control-sm" min="0" step="1"
                                                   [name]="'product_tax_' + i"
                                                   [(ngModel)]="product.pli_tax_rate"
                                                   (ngModelChange)="calculateGrossPrice(product, 'pli_price_recommended'); calculateGrossPrice(product, 'pli_price_max')">
                                        }
                                    </td>
                                    <td class="text-end">
                                        @if (viewMode == ViewMode.VIEW) {
                                            {{ product.pli_price_recommended | number:'1.2-2' }}
                                            <span class="text-muted" *ngIf="!product.pli_price_recommended">Nicht gesetzt</span>
                                        } @else {
                                            <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                                   [name]="'product_rec_' + i"
                                                   [(ngModel)]="product.pli_price_recommended"
                                                   (ngModelChange)="calculateGrossPrice(product, 'pli_price_recommended')">
                                        }
                                    </td>
                                    <td class="text-end">
                                        @if (viewMode == ViewMode.VIEW) {
                                            {{ product.pli_price_recommended_gross | number:'1.2-2' }}
                                            <span class="text-muted" *ngIf="!product.pli_price_recommended_gross">Nicht gesetzt</span>
                                        } @else {
                                            <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                                   [name]="'product_rec_gross_' + i"
                                                   [(ngModel)]="product.pli_price_recommended_gross"
                                                   (ngModelChange)="calculateNetPrice(product, 'pli_price_recommended')">
                                        }
                                    </td>
                                    <td class="text-end">
                                        @if (viewMode == ViewMode.VIEW) {
                                            {{ product.pli_price_max | number:'1.2-2' }}
                                            <span class="text-muted" *ngIf="!product.pli_price_max">Nicht gesetzt</span>
                                        } @else {
                                            <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                                   [name]="'product_max_' + i"
                                                   [(ngModel)]="product.pli_price_max"
                                                   (ngModelChange)="calculateGrossPrice(product, 'pli_price_max')">
                                        }
                                    </td>
                                    <td class="text-end">
                                        @if (viewMode == ViewMode.VIEW) {
                                            {{ product.pli_price_max_gross | number:'1.2-2' }}
                                            <span class="text-muted" *ngIf="!product.pli_price_max_gross">Nicht gesetzt</span>
                                        } @else {
                                            <input type="number" class="form-control form-control-sm" min="0" step="0.01"
                                                   [name]="'product_max_gross_' + i"
                                                   [(ngModel)]="product.pli_price_max_gross"
                                                   (ngModelChange)="calculateNetPrice(product, 'pli_price_max')">
                                        }
                                    </td>
                                    <!--@if (viewMode != ViewMode.INSERT) {
                                        <td>
                                            {{ product.pli_created_at | date:'dd.MM.yyyy, HH:mm' }}
                                        </td>
                                    }-->
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <div class="mt-3">
                    @if (viewMode == ViewMode.VIEW) {
                        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                        <button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>
                        <button type="button" class="btn btn-info float-end me-2" (click)="export()">Exportieren</button>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
                    }
                </div>
            </div>
        </div>
    `
})
export class PriceListDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);

    readonly ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_pricelist!: string;
    viewMode!: ViewMode;
    pricelist: any;
    products: any[] = [];

    ngOnInit(): void {
        this.id_pricelist = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_pricelist == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            name: [null, Validators.required],
            currency: [null, Validators.required],
            created_at: [null],
            valid_from: [moment().format('YYYY-MM-DD')],
            valid_to: [null]
        });

        if (this.id_pricelist !== '0') {
            this.getPriceList();
        } else {
            this.listProducts();
        }
    }

    getPriceList(): void {
        this.dataService.request('PriceList/get', {
            id_pricelist: this.id_pricelist
        }).subscribe(response => {
            this.pricelist = response.pricelist;
            this.products = response.products;

            this.products.forEach(product => {
                this.calculateGrossPrice(product, 'pli_price_recommended');
                this.calculateGrossPrice(product, 'pli_price_max');
            })

            this.patchForm();
        });
    }

    listProducts(): void {
        this.dataService.request('PriceList/listProducts').subscribe(response => {
            this.products = response.products;
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.pricelist.id,
            name: this.pricelist.name,
            currency: this.pricelist.currency,
            created_at: this.pricelist.created_at,
            valid_from: this.pricelist.valid_from,
            valid_to: this.pricelist.valid_to
        });
    }

    save(): void {
        this.dataService.request('PriceList/save', {
            pricelist: this.form.getRawValue(),
            products: this.products,
        }).subscribe(() => {
            this.router.navigate(['/pricelist']);
            this.toastrService.success('Die Preisliste wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('PriceList/update', {
            pricelist: this.form.getRawValue(),
            products: this.products,
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getPriceList();
            this.toastrService.success('Die Preisliste wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/pricelist']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Preisliste wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('PriceList/delete', {
                    id_pricelist: this.id_pricelist
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Die Preisliste wurde gelöscht');
                });
            }
        });
    }

    export(): void {
        this.dataService.request("PriceList/export", {
            id_pricelist: this.id_pricelist
        }).subscribe(response => {
            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = response.filename;
                //a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                setTimeout(() => URL.revokeObjectURL(url), 100);
            }
        });
    }

    protected calculateGrossPrice(product: any, field: string): void {
        if (!product[field]) {
            return;
        }
        product[field + '_gross'] = (product[field] * (1 + product.pli_tax_rate / 100)).toFixed(2);
    }

    protected calculateNetPrice(product: any, field: string): void {
        if (!product[field + '_gross']) {
            return;
        }
        product[field] = (product[field + '_gross'] / (1 + product.pli_tax_rate / 100)).toFixed(2);
    }
}
